import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgCreateFlowsUrl from '@/assets/misc/img_create-flows.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'

export interface BulkCopyJobsDialogProps {
  showing: boolean
  jobsCount: number
  isCopyPending: boolean
  onClose: () => unknown
  onCopy: () => unknown
}

/**
 * Confirms copying the selected jobs.
 */
export function BulkCopyJobsDialog({
  showing,
  jobsCount,
  isCopyPending,
  onClose,
  onCopy,
}: BulkCopyJobsDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isCopyPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgCreateFlowsUrl}
            illustration={byDesign(undefined, TeamRolesIllustration)}
            alt="Clone Jobs"
          />
          <ModalSheetContentTitle>
            You’re about to clone {jobsCount} job
            {jobsCount > 1 ? 's' : ''}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Before proceeding, make sure you have selected the correct jobs.
            Once cloned, this action cannot be undone.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Cancel" isDisabled={isCopyPending} onPress={onClose} />
          <Button
            label="Clone"
            onPress={onCopy}
            isPending={isCopyPending}
            variant="primary"
            testId="copy-job-modal-confirm"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
